import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import AccessLists from '@/views/AccessLists'
import Logged from '@/headers/Logged'
import Home from '@/views/Home'
import { showError } from '@/notifications'
import Devices from '@/views/Devices'
import WhiteLabels from '@/views/WhiteLabels'
import Events from '@/views/Events'
import Access from '@/views/Access'
import AccessLog from '@/views/AccessLog'
import Users from '@/views/Users'
import ErrorPage from '@/views/ErrorPage'
import Products from '@/views/Products'
import Areas from '@/views/Areas'
import DeniedLog from '@/views/DeniedLog'
import Categories from '@/views/Categories'
import Profile from '@/views/Profile'
import Orders from '@/views/Orders'
import EventGroups from '@/views/EventGroups'
import Permissions from '@/views/Permissions'
import ActivityLogs from '@/views/ActivityLogs'
import { authStatus, getServersFromDNS, isAdmin, isAuthenticated, isManager } from '@/globals'
import People from '@/views/People'
import UserGroups from '@/views/UserGroups'
import Webhooks from '@/views/Webhooks'
import EmailLog from '@/views/EmailLog.vue'

const LandPage = () => import(/* webpackChunkName: "public" */ '@/views/Desktop/LandPage')
const Terms = () => import(/* webpackChunkName: "public" */ '@/views/Terms')

const authRequired = true
const adminRequired = true
const managerRequired = true
const publicAccess = true

const routes = [
  {
    path: '/login',
    name: 'Login',
    components: { default: Login }
  },
  {
    path: '/',
    name: 'Home',
    components: {
      default: Home,
      header: Logged
    },
    meta: { authRequired }
  },
  { path: '/terms', components: { default: Terms }, meta: { publicAccess } },
  { path: '/error', name: 'Error', components: { default: ErrorPage }, meta: { publicAccess } },
  { path: '/desktop', components: { default: LandPage }, meta: { publicAccess } },
  { path: '/profile', components: { default: Profile, header: Logged }, meta: { authRequired } },
  { path: '/activity/log', components: { default: ActivityLogs, header: Logged }, meta: { authRequired } },
  { path: '/permissions', components: { default: Permissions, header: Logged }, meta: { authRequired } },
  { path: '/whitelabels', components: { default: WhiteLabels, header: Logged }, meta: { adminRequired } },
  { path: '/users', components: { default: Users, header: Logged }, meta: { authRequired } },
  { path: '/usergroups', components: { default: UserGroups, header: Logged }, meta: { authRequired } },
  { path: '/devices', components: { default: Devices, header: Logged }, meta: { authRequired, title: 'Dispositivos' } },
  { path: '/events', components: { default: Events, header: Logged }, meta: { authRequired, title: 'Eventos' } },
  { path: '/eventgroups', components: { default: EventGroups, header: Logged }, meta: { authRequired } },
  { path: '/areas', components: { default: Areas, header: Logged }, meta: { authRequired } },
  { path: '/categories', components: { default: Categories, header: Logged }, meta: { authRequired } },
  { path: '/lists', components: { default: AccessLists, header: Logged }, meta: { authRequired } },
  { path: '/people', components: { default: People, header: Logged }, meta: { authRequired, title: 'Pessoas' } },
  { path: '/products', components: { default: Products, header: Logged }, meta: { authRequired } },
  { path: '/orders', components: { default: Orders, header: Logged }, meta: { authRequired } },
  { path: '/access', components: { default: Access, header: Logged }, meta: { authRequired } },
  { path: '/access/logs', components: { default: AccessLog, header: Logged }, meta: { authRequired } },
  { path: '/email/logs', name: 'EmailLog', components: { default: EmailLog, header: Logged }, meta: { authRequired, title: 'Emails' } },
  { path: '/access/denied', components: { default: DeniedLog, header: Logged }, meta: { authRequired } },
  { path: '/settings/webhooks', components: { default: Webhooks, header: Logged }, meta: { authRequired } },
  {
    path: '*',
    components: {
      default: ErrorPage
    }
  }
]

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = 'Total Control - ' + to.meta.title
  } else {
    document.title = 'Total Control'
  }

  await getServersFromDNS()

  if (to.matched.some(record => record.meta.publicAccess)) {
    return next()
  }

  await authStatus()

  if (window.g_route) {
    const to = window.g_route
    window.g_route = null
    next(to)
    return
  }

  if (to.matched.some(record => record.meta.managerRequired)) {
    if (isAdmin() || isManager()) {
      return next()
    }
    return next({ name: 'Error', params: { message: 'Para acessar este recurso é necessário uma permissão maior' } })
  }

  if (to.matched.some(record => record.meta.adminRequired)) {
    if (isAdmin()) {
      return next()
    }
    return next({ name: 'Error', params: { message: 'Para acessar este recurso é necessário ser um administrador' } })
  }

  if (to.matched.some(record => record.meta.authRequired)) {
    if (isAuthenticated()) {
      next()
    } else {
      next({ name: 'Login', params: { nextUrl: to.fullPath } })
    }
  } else {
    if (to.name === 'Login' && isAuthenticated()) {
      next({ name: 'Home' })
      return
    }

    next()
  }
})
Vue.use(VueRouter)
export default router
